import React from 'react';
import { ButtonComponent, type ButtonComponentProps } from './ButtonComponent';

export interface DangerButtonProps extends Omit<ButtonComponentProps, 'color' | 'variant'> {
  variant?: 'contained' | 'outlined';
}

/**
 * DangerButton - Red Button Component
 *
 * A specialized button component that provides:
 * - Consistent red/error styling for dangerous or important actions
 * - Based on the standardized ButtonComponent
 * - Defaults to error color and contained variant
 * - Supports all ButtonComponent features (loading, icons, etc.)
 */
const DangerButton: React.FC<DangerButtonProps> = ({
  variant = 'contained',
  ...props
}) => {
  return (
    <ButtonComponent
      {...props}
      color="error"
      variant={variant}
    />
  );
};

export default DangerButton;